import React, { useEffect, useState } from "react";
import SlidePanel from "../../components/SlidePanel/SlidePanel";
import Loader from "../../components/Loader/Loader";
import CustomerPicker from "./CustomerPicker";
import InvoiceDateField from "./InvoiceDateField";
import { todayYmd } from "./expenseStyles";

// "Who is this invoice for?" - shown before every invoice is generated from
// the Jobs grid, together with the invoice date (defaults to today; past or
// future allowed). onConfirm receives (customer, invoiceDate).
function InvoiceCustomerDialog({ show, onHide, onConfirm, busy = false, entryCount = 0 }) {
  const [customer, setCustomer] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(todayYmd);

  useEffect(() => {
    if (show) {
      setCustomer(null);
      setInvoiceDate(todayYmd());
    }
  }, [show]);

  const footer = (
    <>
      <button className="btn btn-outline-secondary px-4" onClick={onHide} disabled={busy}>
        Cancel
      </button>
      <button
        className="btn Button primaryBackground text-white px-4"
        onClick={() => onConfirm(customer, invoiceDate)}
        disabled={!customer || !invoiceDate || busy}
        title={customer ? (invoiceDate ? "" : "Choose the invoice date") : "Select the customer this invoice is for"}
      >
        {busy ? <Loader style={{ width: 40, height: 20 }} /> : "Generate Invoice"}
      </button>
    </>
  );

  return (
    <SlidePanel show={show} onHide={() => !busy && onHide()} title="Generate Invoice" footer={footer} width={560}>
      <p style={{ fontSize: "14px", color: "#374151" }}>
        Choose the invoice date and the customer this invoice is raised against
        {entryCount ? ` (${entryCount} job${entryCount === 1 ? "" : "s"} selected)` : ""}. If they don&apos;t exist yet, create them here.
      </p>
      {/* SlidePanel keeps its children mounted while hidden; only mount the
          picker when open so it doesn't search on every page load. */}
      {show && (
        <>
          <div className="mb-3">
            <InvoiceDateField value={invoiceDate} onChange={setInvoiceDate} />
          </div>
          <CustomerPicker value={customer} onChange={setCustomer} />
        </>
      )}
    </SlidePanel>
  );
}

export default InvoiceCustomerDialog;
